'use strict';

const BaseModel = require('./baseModel');

class ContactProfileModel extends BaseModel {
  constructor() {
    super(contactProfileSchema);
  }

  static getSchema() {
    return contactProfileSchema;
  }
}

const contactProfileSchema = {
  title: {
    required: {
      message: 'This field is required.'
    },
  },
  phoneNumber: {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 10, max: 10},
      message: 'Must be 10 digits'
    },
    isNumeric: {
      message: 'Must be numeric'
    },
    matches: {
      options: /^[2-9]\d{9}$/,
      message: 'Must be a valid phone number.'
    }
  },
  foundUsVia: {
    required: {
      message: 'This field is required.'
    },
  },
  initialInquiry: {
    required: {
      message: 'This field is required.'
    },
  },
};

module.exports = ContactProfileModel;



// WEBPACK FOOTER //
// ./shared/models/contactProfile.js